import React, { useEffect, useState, useRef, useCallback,useMemo} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { CUSTOM_SELECT_DROPDOWN_STYLE, DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Employee } from "../../../common/imagePath";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const TransactionListByCustomer = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(3);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [customerid,setCustomerID] = useState(0)

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const ITEMS_PER_PAGE = 10;
  const locationid=localStorage.getItem("Location")

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet

  useEffect(()=>{
    axios
    .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        Authorization: token,
      },
    })
    .then((response) => {
      setCustOptions(response.data.ResponseData);
      console.log(response.data.ResponseData, "===> setCustOptions");
    })
    .catch((error) => {
      console.log(error);
    });
  },[])

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label: option. CompanyName + '(' + option.FirstName + " " + option.LastName + ')'
     
  }));

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  const paramObject = useParams();
  useEffect(()=>{
    setLoading(true)
    const columnIndex = ((sorting.length > 0) ? sorting[0]?.id : "")

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${config.reportsBaseUrl}/reports/transactionlistbycustomer?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&customerid=${customerid}&locationid=${locationid}&usertype=1`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecords)

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  },[ columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,
    customerid
  ])
    
  
  useEffect(() => {
    
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, data) => {
      const reportTotal = Number(data.Amountline);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  // const columnDefs = [
  //   { field: "CustomerName",enableRowGroup: true },
  //   { field: "TransactionDate",enableRowGroup: true },
  //   { field: "TransactionType",enableRowGroup: true },
  //   { field: "Transactionnumber",enableRowGroup: true },
  //   { field: "Memo",enableRowGroup: true },
  //   { field: "Account",enableRowGroup: true },
  //   {
  //     field: "Amount",
  //     width: 200,
  //     enableValue: true,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     valueGetter: function (params) {
  //       // Parse the string OpenBalance and return as an integer
  //       const amount = parseInt(params.data.Amount, 10);
  //       return isNaN(amount) ? 0 : amount;
  //     },
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size: 120,
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.Date);
        if (transactionDate.isValid()) {
          return transactionDate.format("MM/DD/YYYY");
        } else {
          return "";
        }
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: 120
    },
    {
      header: "Memo/Description",
      accessorKey: "MemoDescription",
    },
    {
      header: "Account",
      accessorKey: "Account",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: 120,
      Cell: ({ row }) => {
        const Amount = parseFloat(row?.original?.Amount);
    
        if (isNaN(Amount) || Amount === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>
              {`${Amount.toFixed(2)}`}
            </div>
          );
        }
      },
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (CreatedDate === "00-00-0000" || CreatedDate === "" || CreatedDate === null) {
          return "";
        }
        return moment(CreatedDate).format("MM/DD/YYYY HH:mm:ss");
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedUser",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModifiedDate",
      Cell: ({ row }) => {
        const LastModifiedDate = row?.original?.LastModifiedDate;
        if (LastModifiedDate === "00-00-0000" || LastModifiedDate === "" || LastModifiedDate === null) {
          return "";
        }
        return moment(LastModifiedDate).format("MM/DD/YYYY HH:mm:ss");
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedUser",
    },
    {
      header: "Customer",
      accessorKey: "Customer",
    },
    {
      header: "Employee",
      accessorKey: "Employee",
    },
    {
      header: "Split",
      accessorKey: "AccountFullName",
    },
    {
      header: "Billing Address",
      accessorKey: "BillingAddress",
    },
    {
      header: "Shipping Address",
      accessorKey: "ShippingAddress",
    },
    {
      header: "Ship Date",
      accessorKey: "ShipDate",
      Cell: ({ row }) => {
        const ShipDate = row?.original?.ShipDate;
        if (ShipDate === "00-00-0000" || ShipDate === "" || ShipDate === null) {
          return "";
        }
        return moment(ShipDate).format("MM/DD/YYYY HH:mm:ss");
      },
    },
    {
      header: "Ship Via",
      accessorKey: "ShipVia",
    },
    {
      header: "Tracking #",
      accessorKey: "Trackingnumber",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
      size: 120,
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: 130,
      Cell: ({ row }) => {
        const DueDate = row?.original?.DueDate;
        if (DueDate === "00-00-0000" || DueDate === "" || DueDate === null) {
          return "";
        }
        return moment(DueDate).format("MM/DD/YYYY");
      },
    },
    {
      header : "Customer/Vendor Message",
      accessorKey : "CustomerVendorMessage"
    },
    {
      header: "Invoice Date",
      accessorKey: "InvoiceDate",
      size: 150,
      Cell: ({ row }) => {
        const InvoiceDate = row?.original?.InvoiceDate;
        if (InvoiceDate === "00-00-0000" || InvoiceDate === "" || InvoiceDate === null) {
          return "";
        }
        return moment(InvoiceDate).format("MM/DD/YYYY");
      },
    },
    {
      header : "A/R Paid",
      accessorKey : "ARPaid",
      size: 130
    },
    {
      header : "Delivery Address",
      accessorKey : "DeliveryAddress"
    },
    {
      header : "Open Balance",
      accessorKey : "OpenBalance",
      size: 160,
      Cell: ({ row }) => row.original.OpenBalance == "0.00" || "" ? '' : row.original.OpenBalance
    }
  ]);

  const defaultColDef = {
    sortable: true,
    resizable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  const downloadPDF = (rows, field, visibleColumns, startdate, enddate) => {
    console.log("visibleColumns=>", visibleColumns);
    let reportMainHeading = "Sonar POS";
    let reportHeading = "TransactionList By Customer";
    let reportDateHeading = startdate && enddate ? `From: ${startdate} To: ${enddate}` : "All Date";
  
    visibleColumns = visibleColumns.filter(
      (col) => col.columnDef.header !== "Select"
    );
  
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData.map((el) => {
        return {
          ...el,
          OpenBalance:
            el.OpenBalance == null || el.OpenBalance === "NaN"
              ? ""
              : formatNumeric(el.OpenBalance),
          ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
          DeliveryAddress: el.DeliveryAddress == null ? "" : el.DeliveryAddress,
        };
      });
    }
  
    const doc = new jsPDF("p", "mm", "a4");
  
    let pageWidth = doc.internal.pageSize.width;
    let pageHeight = doc.internal.pageSize.height;
  
    let itemsPerPage = Math.floor(pageHeight); // Adjust the factor based on your content
    console.log("itemsPerPage=>", itemsPerPage);
  
    doc.setFontSize(10);
  
    for (
      let currentPage = 1, rowNumber = 1;
      rowNumber <= newData.length;
      currentPage++
    ) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = Math.min(currentPage * itemsPerPage, newData.length);
  
      // Dynamic header
      const header = [
        "No",
        ...visibleColumns.map((col) => col.columnDef.header),
      ];
  
      // Extract data for the current page
      const pageData = newData.slice(startIndex, endIndex);
  
      // Calculate header height
      const headerHeight = doc.getTextDimensions(header.join(" ")).h + 2;
  
      // Calculate startY for the first page, and for subsequent pages, consider header height
      const startY = currentPage === 1 ? 25 : headerHeight; // Adjust as needed
  
      // Build the table content
      const content = {
        startY: startY,
        head: [header],
        body: pageData.map((row) => {
          // Parse row data dynamically
          const parsedRow = visibleColumns.map((col) => {
            const dataValue = row[col.columnDef.id];
            let value = "";
  
            if (typeof dataValue === "number") {
              value = formatNumeric(dataValue);
            } else if (typeof dataValue === "string") {
              value = dataValue;
            } else if (moment(dataValue).isValid()) {
              value = moment(dataValue).format("YYYY-MM-DD (HH:mm)");
            }
  
            return value;
          });
  
          return [rowNumber++, ...parsedRow];
        }),
        headStyles: { fillColor: [100, 100, 100] },
      };
  
      // Add the header on every page
      let textWidth =
        (doc.getStringUnitWidth(reportMainHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerX = (pageWidth - textWidth) / 2;
      doc.text(reportMainHeading, centerX, 10);
  
      let textWidthHeading =
        (doc.getStringUnitWidth(reportHeading) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXHeading = (pageWidth - textWidthHeading) / 2;
      doc.text(reportHeading, centerXHeading, 15);
  
      let textWidthDate =
        (doc.getStringUnitWidth(reportDateHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXDate = (pageWidth - textWidthDate) / 2;
      doc.text(reportDateHeading, centerXDate, 20);
  
      doc.setPage(currentPage);
      doc.autoTable(content);
  
      // Add page break if not the last page
      if (currentPage < Math.ceil(newData.length / itemsPerPage)) {
        doc.addPage();
      }
    }
  
    doc.save("TransactionList_By_Customer.pdf");
  };
  
  // Function to format numeric values to two decimal places
  const formatNumeric = (value) => {
    return !isNaN(value) ? parseFloat(value).toFixed(2) : "";
  };
  
  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyProduct_ServiceDetails_.xlsx`);
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `TransactionListByCustomer_.xlsx`);
  };

  const handleDownloadPDF = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(responseData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Customer Name</th>' +
        '<th style="padding: 7px;">Transaction Date</th>' +
        '<th style="padding: 7px; ">Transaction Type</th>' +
        '<th style="padding: 7px;">Transaction Number</th>' +
        '<th style="padding: 7px;">Memo</th>' +
        '<th style="padding: 7px; ">Account</th>' +
        '<th style="padding: 7px; text-align: right;">Amount</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(data[index - 1].Date).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].TransactionDate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Transactionnumber +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Account +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Transaction-list.pdf");
        setLoading(false);
      },
    });
  };

  const handlePrintPDF = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(responseData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Printing table body-
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Customer Name</th>' +
        '<th style="padding: 7px;">Transaction Date</th>' +
        '<th style="padding: 7px; ">Transaction Type</th>' +
        '<th style="padding: 7px;">Transaction Number</th>' +
        '<th style="padding: 7px;">Memo</th>' +
        '<th style="padding: 7px; ">Account</th>' +
        '<th style="padding: 7px; text-align: right;">Amount</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= responseData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(data[index - 1].Date).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].TransactionDate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Transactionnumber +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Account +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";
    }

    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        setLoading(false);
        pdf.output("dataurlnewwindow");
      },
    });
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Transaction List By Customer</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Transaction List By Customer
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
          {/* <div
                  className=" mt-0 col-md-3"
                >
                <label className="col-form-label col-md-5 form-label p-lg-medium">
                     Customer
                </label>
                  
                  <Select
                    defaultValue={customerid}
                    onChange={(event) => {
                      setCustomerID(event?.value);
                    }}
                    options={customerDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div> */}
            <div className="col-sm-3">
            <label className="col-form-label col-md-5 form-label p-lg-medium">
                  Report period
                </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            {/* <div className="col-sm-2 align-self-sm-end">
            <button
              type="submit"
              className="btn btn-primary pull-right"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div> */}

          </div>

          {/* Receipt */}

          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">
                    Transaction List By Customer
                  </p>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    {/* <p>
                      Date: {startdate} - {enddate}
                    </p> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              {/* <div className="button">
                <button
                 onClick={onBtExport}
                 className="btn btn-sm btn-outline-dark  m-1"
            // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
               >
                <i class="fas fa-file-excel mr-2"></i>
               Export to Excel
                </button>
             <button
              onClick={handleDownloadPDF}
              className="btn btn-sm btn-outline-dark  m-1"
            // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
            >
              <i class="fas fa-file-export mr-2"></i>
            Export to Pdf
          </button>
          <button  className="btn btn-sm btn-outline-dark  m-1" onClick={handlePrintPDF}> <i class="fas fa-print mr-2"></i>Print</button>
               </div> */}

              {/* { headerName: "CustomerName", minWidth: 130 } */}
              {/* <div className="table-responsive">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100vh", width: "100%" }}
                >
                  <AgGridReact
                    rowData={data}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    autoGroupColumnDef={autoGroupColumnDef}
                    onGridReady={onGridReady}
                    rowGroupPanelShow={'always'}
                  ></AgGridReact>
                </div>


                
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div> */}
              <div>
                <MaterialReactTable
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  columns={columns}
                  data={responseData}
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  sortDescFirst
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    grouping: ["Customer"], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 50 },
                    sorting: [{ id: "state", desc: false }],
                    columnVisibility:{
                      CreatedDate:false,
                      CreatedUser:false,
                      LastModifiedDate:false,
                      LastModifiedUser:false,
                      ShipDate:false,
                      PaymentMethod:false,
                      CustomerVendorMessage:false,
                      InvoiceDate:false,
                      Terms:false,
                      ShipVia:false,
                      AccountFullName:false,
                      BillingAddress:false,
                      ShippingAddress:false,
                      DeliveryAddress:false,
                      POStatus:false,
                      DueDate:false,
                      ARPaid:false,
                      APPaid:false,
                      Employee:false,
                      OpenBalance:false,
                      Trackingnumber:false
                    } //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [50, 100, 300, 500],
                  }}
                  // manualFiltering
                  manualPagination
                  manualSorting
                  // muiToolbarAlertBannerProps={
                  //   isError
                  //     ? {
                  //         color: "error",
                  //         children: "Error loading data",
                  //       }
                  //     : undefined
                  // }
                  muiTableBodyProps={{
                    sx: () => ({
                      "& tr:nth-of-type(even)": {
                        backgroundColor:
                          "var(--datatable-row-background-color)",
                        //'rgb(237 237 233 / 63%)'
                      },
                      "& td": {
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },

                      "& tr": {
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },
                    }),
                  }}
                  muiTableHeadCellProps={{
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiToolbarAlertBannerProps={
                    // isError
                    // ? {
                    //   color: "error",
                    //   children: "Error loading data",
                    // }
                    // : undefined
                    {
                      isError: () => ({
                        color: "error",
                        children: "Error loading data",
                      }),
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }
                  }
                  muiSelectCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiSelectAllCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  onColumnFiltersChange={setColumnFilters}
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  state={{
                    columnFilters,
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                    sx={{
                      display: "flex",
                      gap: "0.5rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={onBtExport}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Excel
                    </Button>
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleExportRows(table.getSelectedRowModel().rows)
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Excel
                    </Button>
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      color="primary"
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={() => downloadPDF("", "alldata",table.getVisibleFlatColumns())}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Pdf
                    </Button>
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        downloadPDF(
                          table.getSelectedRowModel().rows,
                          "selectedrow",
                          table.getVisibleFlatColumns()
                        )
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Pdf
                    </Button>
                  </Box>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionListByCustomer;
